import { useMemo } from 'react';
import { useSearchingStore } from '../store/useSearchStore';
import { buildSkipConditions } from '../utils/skip-logic';
import { useUnifiedSearch } from './useUnifiedSearch';

export const useList = () => {
  const filtersSelected = useSearchingStore((state) => state.filters);
  const fixedTypes = useSearchingStore((state) => state.fixedTypes);
  const page = useSearchingStore((state) => state.page);
  const setPage = useSearchingStore((state) => state.setPage);

  const skipConditions = useMemo(() => buildSkipConditions(filtersSelected, fixedTypes), [filtersSelected, fixedTypes]);

  const shouldSkip = skipConditions.queries;

  const unified = useUnifiedSearch(filtersSelected, page, shouldSkip);

  return {
    items: unified.items,
    page: unified.pageInfo.page,
    pageCount: unified.pageInfo.pageCount,
    total: unified.pageInfo.total,
    isLoading: unified.isLoading,
    setPage,
  };
};
